import { Component } from '@angular/core';


@Component({
    selector: 'sequencer-abstract',
    template: '<ui-view></ui-view>'
})
export class SequencerAbstractComponent {}
